import { Component } from '@angular/core';
import { 
  NavController, 
  ViewController,
  NavParams
} from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Pages
import { InstructorAddEditPage } from '../../pages/instructors/instructor-add-edit';

@Component({
  template: `
    <ion-list>
      <button *ngFor="let in of instructorNames; let i = index" ion-item (click)="showInstructorAddEditPage(instructorRegistryNumbers[i])">    
        {{ in }} ({{ instructorRegistryNumbers[i] }})
      </button>
    </ion-list>  
  `
})
export class CertifiedHoursPopoverPage {
  secureDataSubmitId = 0;
  instructorNames = [];
  instructorRegistryNumbers = [];

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public providersService: ProvidersService,
    public instructorsService: InstructorsService
  )
  {
    if ( this.navParams.get('secureDataSubmitId') )
    {
      this.secureDataSubmitId = this.navParams.get('secureDataSubmitId');
      this.getSecureDataMessage();
    }
  }

  getSecureDataMessage()
  {
    this.providersService.getSecureDataRequest( this.secureDataSubmitId )
      .subscribe( data => {
        let d:any = data;

        // Parse instructor names and registry numbers.
        this.instructorNames = d.instructor_names.split(', ');
        this.instructorRegistryNumbers = d.instructor_registry_numbers.split(', ');
      });
  }

  showInstructorAddEditPage( registryNumber )
  {
    this.instructorsService.getInstructorByRegistryNumber( registryNumber )
      .subscribe( data => {
        this.navCtrl.push( InstructorAddEditPage, {
          instructor: data
        });
      });
    return false;
  }

  closePopover( selectedItem )
  {
    this.viewCtrl.dismiss( selectedItem );
  }

}



// WEBPACK FOOTER //
// ./src/components/popovers/certified-hours.popover.ts